<div class="loader" [ngClass]="{'filter-overlay': filterOverlay, 'loader-overlay': overlay, 'card-overlay': cardOverlay}" *ngIf="loading">
  <mat-spinner *ngIf="!filterOverlay" [diameter]="size" [color]="color"></mat-spinner>
</div>
